// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout_Layout__1RN_R","LayoutCodePage":"Layout_LayoutCodePage__2tc-h","childrenContainer":"Layout_childrenContainer__t2u8E","fadeIn":"Layout_fadeIn__1sRE9"};